// src/components/NsfwWarningModal.tsx
import React from 'react';
import Modal from './Modal'; // Assuming Modal component exists and works

interface NsfwWarningModalProps {
  contentType: 'subreddit' | 'post'; // Type of content being warned about
  onConfirm: () => void; // Callback when user confirms to proceed
  onDecline: () => void; // Callback when user declines/closes
}

const NsfwWarningModal: React.FC<NsfwWarningModalProps> = ({ contentType, onConfirm, onDecline }) => {
  return (
    <Modal isOpen={true} onClose={onDecline} title="Content Warning">
      <div className="space-y-4 text-center">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          {/* Exclamation Icon */}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold leading-6 text-gray-900 dark:text-gray-100">
          Adult Content Warning
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The {contentType} you are trying to view is marked as Not Safe For Work (NSFW) / 18+.
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Do you wish to proceed?
        </p>
      </div>
      <div className="mt-6 flex flex-col sm:flex-row-reverse sm:gap-3 gap-2">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 sm:w-auto"
          onClick={onConfirm}
        >
          Proceed (I am 18+)
        </button>
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-white dark:bg-gray-700 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-200 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 sm:mt-0 sm:w-auto"
          onClick={onDecline}
        >
          Go Back
        </button>
      </div>
    </Modal>
  );
};

export default NsfwWarningModal;